import { IKioskModel } from "models/kioskModel";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import "../../Kiosk.css";
import QRCode from "react-qr-code";
import { getExistQRString } from "helpers/configandapiurls";

const PatientJouneyExistPage: React.FC = () => {
  const { t } = useTranslation("translations");
  const dispatch = useDispatch();
  const language = useSelector((state: any) => {
    if (state?.kioskReducer?.language)
      return (state.kioskReducer as IKioskModel).language;
    else return "";
  });
  return (
    <>
      <div className="kiosk-content bgImage">
        <Row className="content-sec">
          <Col sm="6" className="welcometext">
            <div className="thank_you_blk">
              <div className="thnk_you_msg">
                {t("Kiosk.thankyourtTime" + language)}
              </div>
              <p>{t("Kiosk.qrText" + language)}</p>
              <QRCode value={getExistQRString()} size={250} />
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default React.memo(PatientJouneyExistPage);
